import React, { Component } from 'react'
import {connect} from 'react-redux'
import {Modal} from '@material-ui/core'
import {modalToggleReset,modalToggle} from 'redux/actions/general'
import {isMobile} from 'react-device-detect'
import Alert from './src/alert'
import Add_diskusi from './src/add_diskusi'
import Filter from './src/filter'
import FilterSearch from './src/filter_search'
import Sortir from './src/sortir'
import Search from './src/search'
import Profile from './src/Profile'
import Add_comment from './src/add_comment'
import Reply_comment from './src/reply_comment'
import Close from 'assets/icon/close.png'
import Delete from './src/delete'
import './style.css' 
class index extends Component {
   
    renderBody=()=>{
        const {modal_data,modal_title,modal_component,modal_type,modal_action}=this.props.general
        const {token,profile}=this.props
        // console.log(`modal_component`, modal_component)
        switch (modal_type) {
            case 'alert':
                return <Alert token={token}/>
            case 'delete':
                return <Delete modal_data={modal_data} modalToggleReset={this.props.modalToggleReset}/>
            // case 'play_video':
            //     return <PlayVideo modal_data={modal_data}/>
            default:
                return(
                        <div>
                            <div className='modal-header'>
                                    <h2>{modal_title}</h2>
                                    <img src={Close} style={{height:20}}  onClick={()=>modal_component==="assignment_peserta"?this.emailTemplate():this.props.modalToggleReset()}/>
                            </div>
                                {/* <hr className='modal-hr' size='1'/> */}
                            <div className='modal-body' >
                                {modal_component==='add_diskusi'&&<Add_diskusi modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='filter'&&<Filter modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='sortir'&&<Sortir modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='search'&&<Search modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='profile'&&<Profile modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='add_comment'&&<Add_comment modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='reply_comment'&&<Reply_comment modal_action={modal_action} modal_data={modal_data} />}
                                {modal_component==='filter_search'&&<FilterSearch modal_action={modal_action} modal_data={modal_data} />}
                            </div>
                        </div>
                )
                break;
        }
    }
    render() {
        const {modal_open,modal_data,modal_title,modal_component,modal_size,modal_type,modal_action}=this.props.general
        return (
            <div>
                {modal_type!=='profile'?
                <Modal
                    className='modal'
                    open={modal_open}
                    onClose={modal_component!=='upload_file'&&modal_type!=='prosess'&&this.props.modalToggleReset}
                >
                   <div className='modal-content' style={{width:isMobile?'100%':modal_size}}>
                        {this.renderBody()}
                   </div>
                </Modal>
                :
                <Modal
                    className='modal-profile'
                    open={modal_open}
                    onClose={this.props.modalToggleReset}
                >
                    
                   <div className='modal-content' style={{width:modal_size}}>
                   </div>
                </Modal>
                }
            </div>
        )
    }
}
const mapStateToProps=(state)=>{
    return{
        general:state.general
    }
}
const mapDispatchToProp={
    modalToggleReset,modalToggle
}
export default connect(mapStateToProps,mapDispatchToProp)(index)